<template>
  <div class="our-school">
    <div class="image-head">
      <img src="@/assets/sports.jpg" alt="inspire sports t-shirts">
    </div>
    <section class="home-cards">
      <h4>I L S</h4>
      <div class="home-cards-main">
        <div class="home-cards-cards">
          <div class="feature">
            <router-link
            :to="{ name: 'SchoolBus'}">
            <div class="feature-img">
              <img src="../assets/school-bus.svg" alt="school bus">
            </div>
            <div class="feature-title">
              <h5>School Buses</h5>
            </div>
            <div class="feature-detail">
              <p>Time buses with strictly adhered to and easily monitored routes covering most of Lusaka.</p>
            </div>
            </router-link>
          </div>
          <div class="feature">
            <router-link
            :to="{ name: 'Meals'}">
            <div class="feature-img undraw">
              <img src="../assets/breakfast.svg" alt="food">
            </div>
            <div class="feature-title">
              <h5>Meals</h5>
            </div>
            <div class="feature-detail">
              <p>Healthy and delicious meals prepared by the school.</p>
            </div>
            </router-link>
          </div>
          <div class="feature">
            <router-link
            :to="{ name: 'Clubs'}">
            <div class="feature-img">
              <img src="../assets/chess-board.svg" alt="chess">
            </div>
            <div class="feature-title">
              <h5>Extra curricular Activities</h5>
            </div>
            <div class="feature-detail">
              <p>Extra-curricular activities, Chess, Debate etc</p>
            </div>
            </router-link>
          </div>
          <div class="feature">
            <router-link
            :to="{ name: 'Events'}">
            <div class="feature-img undraw">
              <img src="../assets/goal.svg" alt="sport">
            </div>
            <div class="feature-title">
              <h5>Other features</h5>
            </div>
            <div class="feature-detail">
              <p>Sports, field trips, Computer lessons, Music and French classes</p>
            </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="home-footer flex flex-column">
      <div class="footer-conmap">
        <div class="footer-content flex flex-column">
            <h2>Inspire Leadership School</h2>
            <h4>Creating Leaders Through Education</h4>
            <address>
              CONTACT US<br/>
              Call: 0978730723/0976130005 <br/>
              Email: inspireleadershipschool@gmail.com <br/>
              Visit: Plot no 31379 off Ring Road Chalala Lusaka, Zambia
            </address>
            <router-link
                class="btn"
                :to="{ name: 'Welcome' }"
            >
                Login
            </router-link>
            <div class="socials flex">
              <a href="mailto:inspireleadershipschool@gmail.com" class="icon" target="_blank">
                <img src="../assets/email.svg" alt="email">
              </a>
              <a href="https://facebook.com/inspireleadershipschool" class="icon" target="_blank">
                <img src="../assets/facebook.svg" alt="facebook">
              </a>
            </div>
        </div>
        <div class="footer-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3845.6953770168543!2d28.349443315017457!3d-15.446984118621321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19408c54ac0526bd%3A0xf7969458efffeb6d!2sInspire%20Leadership%20School!5e0!3m2!1sen!2szm!4v1651520823014!5m2!1sen!2szm" width="300" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
      <p class="copy">&copy; 2023 <br>
        Developed by <a href="https://schools.vitowe.com" class="vitowe" target="_blank">
        Vitowe</a>
      </p>
    </section>
  </div>
</template>

<script>

export default {
  name: 'OurSchool',
  components: { }
}
</script>

<style>
.our-school .image-head {
  margin-bottom: -1em;
}
.our-school .home-cards {
  background-color: var(--inspire-magnet);
  min-height: 50vh;
}
.our-school .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.our-school .home-cards a {
  text-decoration: none;
  color: inherit;
}
.our-school .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.our-school .home-cards .home-cards-main {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: 1em;
}
.our-school .home-cards .home-cards-cards {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
.our-school .home-cards-cards .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.our-school .home-cards-cards .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.our-school .home-cards-cards .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.our-school .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.our-school .feature .feature-img.undraw {
  width: 75px;
  margin: 5px auto;
}
.our-school .home-cards-cards .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
  background-color: var(--inspire-gold);
}
</style>
